const clearContentsAtSchedule = () => {
    const initialMessage = document.querySelector(".reservation-section-2 div.initial-message");
    if (initialMessage) {
        initialMessage.remove();
    }
    const scheduleTable = document.querySelector(".reservation-section-2 table");
    if (scheduleTable) {
        scheduleTable.remove();
    }
};
const handleRequestSuccess = (xhr) => () => {
    var _a;
    const response = JSON.parse(xhr.response);
    clearContentsAtSchedule();
    const rows = response.map((classScheduleRecord) => `
    <tr class="class">
    <td class="first">
      <input class="radio" id="lesson${classScheduleRecord["$id"]["value"]}" type="radio" name="lesson" value="${classScheduleRecord["$id"]["value"]}" data-class_id=${classScheduleRecord["class_id"]["value"]}>
      <label class="radio" for="lesson${classScheduleRecord["$id"]["value"]}"></label>
    </td>
    <td class="second">${classScheduleRecord["date"]["value"]} ${classScheduleRecord["start_time"]["value"]}-${classScheduleRecord["end_time"]["value"]}</td>
    </tr>
    `);
    (_a = document
        .querySelector("#reservation-form table.class-information tbody")) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML("afterend", rows.join(""));
    // レッスンがクリックされた時のハンドラを登録
    const lessonTrs = document.querySelectorAll("#reservation-form table tr:not(.disabled)");
    lessonTrs.forEach((tr) => {
        tr.addEventListener("click", (e) => {
            const radio = e.target.querySelector("input");
            if (radio) {
                radio.checked = true;
            }
            lessonTrs.forEach((tr) => {
                tr.classList.remove("selected");
            });
            tr.classList.add("selected");
        });
    });
};
export default handleRequestSuccess;
